module.exports = __webpack_public_path__ + "static/img/1063_big.ddd87d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1063_big.png
// module id = HWjR
// module chunks = 1